/**
 * Textos del panel de inicio (2026-08-05; al diseño de las maquetas el 2026-10-30). Los
 * indicadores del periodo usan las claves `KPI.*` de `@features/dashboard-kpis/i18n`.
 */
export const DASHBOARD_LOCALE_ES = {
  DASHBOARD: {
    TITLE: 'Panel',
    // V-A02: un saludo sencillo y la fecha, sin emoji.
    GREETING: {
      MORNING: 'Buenos días',
      AFTERNOON: 'Buenas tardes',
      EVENING: 'Buenas noches',
    },
    SUMMARY: '{{ greeting }}, {{ name }}. Resumen del {{ weekday }} {{ date }}.',
    SUMMARY_NO_NAME: '{{ greeting }}. Resumen del {{ weekday }} {{ date }}.',
    TODAY: {
      TITLE: 'Cifras de hoy',
      BOOKINGS: 'Reservas de hoy',
      YESTERDAY: '{{ count }} ayer',
      PENDING: 'Pendientes de pago',
      PENDING_LINK: 'Ver pendientes',
      REVENUE: 'Venta cobrada de hoy',
      REVENUE_NOTE: 'De las reservas creadas hoy y cobradas.',
      CALLS: 'Llamadas fallidas a Hotelbeds hoy (UTC)',
      CALLS_OF: 'de {{ total }}',
      CALLS_LINK: 'Ver llamadas',
      ERROR: 'No pudimos cargar las cifras de hoy.',
    },
    ATTENTION: {
      TITLE: 'Requiere tu atención',
      SUBTITLE: 'Reservas en un estado que no se resuelve solo. Cuenta todo el histórico, no solo el rango de fechas de abajo.',
      ALL_CLEAR: 'Nada pendiente: ninguna reserva requiere intervención.',
      OTHERS_CLEAR: 'Nada pendiente en {{buckets}}.',
      AND: 'y',
      SEE_ALL: 'Ver en Reservas',
      GUEST: 'Invitado',
      NO_REFERENCE: 'sin referencia',
      BADGE_ACTION: 'Requiere acción',
      BADGE_WAITING: 'En espera',
      BADGE_INFO: 'Para revisar',
      BADGE_REFUNDED: 'Reembolsada',
      BADGE_EXPIRED: 'Caducada',
      FAILED: 'Pagos fallidos',
      FAILED_HINT: 'Puede haber cobro sin reserva confirmada.',
      PARTIALLY_CONFIRMED: 'Confirmación por revisar',
      PARTIALLY_CONFIRMED_HINT: 'Parte de las habitaciones no se confirmó. Comprueba el estado en Hotelbeds antes de reintentar.',
      PENDING_PAYMENT: 'Pendientes de pago',
      PENDING_PAYMENT_HINT: 'Esperan a que el cliente complete el pago. A las 24 horas sin pagar caducan solas.',
      REFUNDED: 'Reembolsadas',
      REFUNDED_HINT: 'Revisa el motivo y si hay que avisar al cliente.',
      NOTE_FAILED_REFUNDED: 'Fallidas con el pago ya devuelto: {{ count }}. No hay cobro sin reserva.',
      NOTE_EXPIRED_PENDING: 'Caducadas sin pagar: {{ count }}. Ya no se pueden pagar y no piden nada.',
      ERROR_TITLE: 'No pudimos cargar lo que requiere tu atención',
      ERROR_DESC: 'No sabemos si hay reservas pendientes. Recarga la página en un momento.',
    },
    HEALTH: {
      CONTENT_TITLE: 'Contenido de Hotelbeds',
      CONTENT_NOTE: 'La web lee esta copia local: durante una reserva no se consulta el contenido a Hotelbeds. Horas en tu hora local.',
      CATALOG_STATE: {
        HEALTHY: 'Al día',
        DEGRADED: 'Con avisos',
        STALLED: 'Parada',
        FAILING: 'Con fallos',
        NEVER_SUCCEEDED: 'Sin sincronizar',
      },
      SYSTEM_TITLE: 'Conexión y tipos de cambio',
      LOAD_ERROR: 'No pudimos cargar este estado. Recarga la página en un momento.',
      PROVIDER: 'Conexión con Hotelbeds',
      PROVIDER_OK: 'Conectado',
      PROVIDER_KO: 'Sin conexión',
      CATALOG_HOTELS: 'Hoteles guardados',
      CATALOG_LAST_SUCCESS: 'Última sincronización correcta',
      CATALOG_FAILED: 'Destinos con fallo',
      CATALOG_LINK: 'Ir al catálogo',
      NEVER: 'Nunca',
      FX: 'Tipos de cambio activos',
      FX_NONE_BADGE: 'Ninguno',
      FX_NONE: 'Sin tipos de cambio activos no se puede vender fuera de la moneda del proveedor.',
      FX_DAYS: 'hace {{ days }} días',
      FX_NO_DATE: 'sin fecha',
      FX_STALE_HINT: 'Una tasa desactualizada afecta a todos los precios de venta.',
      FX_PAIRS: '{{count}} pares',
      FX_LINK: 'Gestionar tipos de cambio',
    },
  },
};
